// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter, Update } from '@ngrx/entity';
// Actions
import { PatientWeightActions, PatientWeightActionTypes } from '../_actions/patient-weight.actions';
// Models
import { PatientWeightModel } from '../_models/patient-weight.model';
import { QueryParamsModel } from '../../_base/crud';

export interface PatientWeightsState extends EntityState<PatientWeightModel> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedPatientWeightId: number;
  lastQuery: QueryParamsModel;
  showInitWaitingMessage: boolean;
  error: any | null;
}

export const adapter: EntityAdapter<PatientWeightModel> = createEntityAdapter<PatientWeightModel>();

export const initialPatientWeightsState: PatientWeightsState = adapter.getInitialState({
  patientWeightForEdit: null,
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  lastCreatedPatientWeightId: undefined,
  lastQuery: new QueryParamsModel({}),
  showInitWaitingMessage: true,
  error: null,
});

export function patientWeightsReducer(
  state = initialPatientWeightsState,
  action: PatientWeightActions,
): PatientWeightsState {
  switch (action.type) {
    case PatientWeightActionTypes.PatientWeightsPageToggleLoading: {
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedPatientWeightId: undefined,
      };
    }
    case PatientWeightActionTypes.PatientWeightActionToggleLoading: {
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    }
    case PatientWeightActionTypes.PatientWeightOnServerCreated:
      return {
        ...state,
      };
    case PatientWeightActionTypes.PatientWeightCreated:
      return adapter.addOne(action.payload.patientWeight, {
        ...state,
        lastCreatedPatientWeightId: action.payload.patientWeight.id,
      });
    case PatientWeightActionTypes.PatientWeightUpdated:
      return adapter.updateOne(action.payload.partialPatientWeight, state);
    case PatientWeightActionTypes.PatientWeightStatusUpdated: {
      // tslint:disable-next-line
      const _partialPatientWeight: Update<PatientWeightModel> = {
        id: action.payload.patientWeight.id,
        changes: {
          is_active: action.payload.is_active,
        },
      };
      // tslint:disable-next-line:prefer-const
      // tslint:disable-next-line
      return adapter.updateOne(_partialPatientWeight, state);
    }
    case PatientWeightActionTypes.PatientWeightsStatusUpdated: {
      // tslint:disable-next-line
      const _partialPatientWeights: Update<PatientWeightModel>[] = [];
      // tslint:disable-next-line:prefer-const
      // tslint:disable-next-line
      for (let i = 0; i < action.payload.patientWeights.length; i++) {
        _partialPatientWeights.push({
          id: action.payload.patientWeights[i].id,
          changes: {
            is_active: action.payload.is_active,
          },
        });
      }
      return adapter.updateMany(_partialPatientWeights, state);
    }
    case PatientWeightActionTypes.OnePatientWeightDeleted:
      return adapter.removeOne(action.payload.id, state);
    case PatientWeightActionTypes.ManyPatientWeightsDeleted:
      return adapter.removeMany(action.payload.ids, state);
    case PatientWeightActionTypes.PatientWeightsPageCancelled: {
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    }
    case PatientWeightActionTypes.PatientWeightsPageLoaded: {
      return adapter.addMany(action.payload.patientWeights, {
        ...initialPatientWeightsState,
        totalCount: action.payload.totalCount,
        listLoading: false,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
      });
    }
    case PatientWeightActionTypes.ThrowPatientWeightError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case PatientWeightActionTypes.ClearPatientWeightErrors: {
      return {
        ...state,
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getPatientWeightState = createFeatureSelector<PatientWeightModel>('patientWeights');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
